package gr.tech.meetinggenie.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.meetinggenie.models.meeting.WinDTO
import gr.tech.meetinggenie.styles.*
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun WinsTableInput(
    wins: List<WinDTO>,
    onUpdate: (List<WinDTO>) -> Unit,
) {
    DraggableDataTable(
        rowCount      = wins.size,
        onMove        = { from, to -> onUpdate(wins.toMutableList().also { it.add(to, it.removeAt(from)) }) },
        onDelete      = { index   -> onUpdate(wins.toMutableList().also { it.removeAt(index) }) },
        addButtonText = "More Wins?",
        onAdd         = { onUpdate(wins + WinDTO()) },
        headers = {
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(160.px).toAttrs()) { Text("Deal Name") }
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(160.px).toAttrs()) { Text("Deal Size / Impact") }
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(220.px).toAttrs()) { Text("Why This Win Matters") }
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(120.px).toAttrs()) { Text("Win Size") }
        },
        rowCells = { index ->
            val win = wins[index]

            // Deal Name
            Td(DataEntryCellStyle.toModifier().minWidth(160.px).padding(0.px).toAttrs()) {
                autoResizeTextArea(
                    value = win.dealName,
                    onInput = { v -> onUpdate(wins.toMutableList().also { it[index] = it[index].copy(dealName = v) }) }
                )
            }

            // Deal Size / Impact
            Td(DataEntryCellStyle.toModifier().minWidth(160.px).padding(0.px).toAttrs()) {
                autoResizeTextArea(
                    value = win.dealSizeOrImpact,
                    onInput = { v -> onUpdate(wins.toMutableList().also { it[index] = it[index].copy(dealSizeOrImpact = v) }) }
                )
            }

            // Why This Win Matters
            Td(DataEntryCellStyle.toModifier().minWidth(220.px).padding(0.px).toAttrs()) {
                autoResizeTextArea(
                    value = win.whyThisWinMatters,
                    onInput = { v -> onUpdate(wins.toMutableList().also { it[index] = it[index].copy(whyThisWinMatters = v) }) }
                )
            }

            // Win Size — radio 1 / 2 / 3
            Td(DataEntryCellStyle.toModifier().minWidth(120.px).padding(4.px).toAttrs()) {
                Column(verticalArrangement = Arrangement.Top) {
                    listOf(1, 2, 3).forEach { size ->
                        Label(
                            forId = "win-size-$index-$size",
                            attrs = RadioLabelStyle.toModifier().toAttrs()
                        ) {
                            Input(
                                type = InputType.Radio,
                                attrs = Modifier.margin(right = 4.px).toAttrs {
                                    id("win-size-$index-$size")
                                    attr("name", "win-size-$index")
                                    checked(win.winSize == size)
                                    onClick {
                                        onUpdate(wins.toMutableList().also { it[index] = it[index].copy(winSize = size) })
                                    }
                                }
                            )
                            Span(
                                attrs = Modifier
                                    .position(Position.Relative)
                                    .whiteSpace(WhiteSpace.NoWrap)
                                    .toAttrs()
                            ) {
                                repeat(size) { fireIndex ->
                                    Span(
                                        attrs = Modifier
                                            .position(Position.Absolute)
                                            .left((fireIndex * 6).px)
                                            .top(0.px)
                                            .toAttrs()
                                    ) { Text("🔥") }
                                }
                            }
                        }
                    }
                }
            }
        }
    )
}

/** Auto-resizing textarea styled for table cells. */
@Composable
fun autoResizeTextArea(value: String, onInput: (String) -> Unit) {
    TextArea(
        value = value,
        attrs = stringInputStyle.toModifier().noBorder().resize(Resize.None)
            .overflow(Overflow.Hidden).toAttrs {
                ref { el ->
                    el.style.height = "auto"
                    el.style.height = "${el.scrollHeight}px"
                    onDispose {}
                }
                onInput { event ->
                    event.target.style.height = "auto"
                    event.target.style.height = "${event.target.scrollHeight}px"
                    onInput(event.value)
                }
            }
    )
}
